import React, {Component} from "react";
import {connect} from 'react-redux';
import {FormControl, Grid, IconButton, MenuItem, Select, Stack, TextField, Tooltip} from "@mui/material";
import {updateSlideData} from "../../../action/maps.state.action";
import {ReplayOutlined} from "@mui/icons-material";
import {getSettingComponent} from "../utils/settingsUtils";
import {BrightnessKey, ContrastKey} from "../keys/Settings";
import {LoadingText} from "./components";
import {createViewerSetting, loadViewerSettings, updateViewerSetting} from "../../../action/viewer.settings.actions";
import {mapStateToProps} from "../sidebarTop_apps/settings";


class SettingsApp extends Component {

	constructor(props) {
		super(props);
		this.rowHeight = '89px';

		this.state = {};
		this.props.dispatch(loadViewerSettings());
	}

	backup = () => {
		if (!this.props.slideState.backupBloodViewerSettings ||
			this.props.slideState.backupBloodViewerSettings.id !== this.props.bloodViewerSetting.id)
			this.props.slideState.backupBloodViewerSettings = {...this.props.bloodViewerSetting}
	}


	updateViewerSettingId = id =>
		this.props.dispatch(updateSlideData(this.props.activeMapId, this.props.slide.id, {
			bloodsettings: id,
		}));

	restoreSettings = () => {
		if (this.props.slideState.backupBloodViewerSettings) {
			this.props.dispatch(updateViewerSetting(this.props.slideState.backupBloodViewerSettings.id,
				this.props.slideState.backupBloodViewerSettings));
			this.updateViewerSettingId(this.props.slideState.backupBloodViewerSettings.id);
		}
	}

	update = (setting, value) =>
		this.props.dispatch(updateViewerSetting(this.props.bloodViewerSetting.id, {
			[setting.name.toLowerCase()]: parseInt(value),
		}));

	getViewerSettingsDropdown = () =>
		<Tooltip title={"Choose Settings"} placement={"left"}>
			<Select value={this.props.bloodViewerSetting} MenuProps={{
				anchorOrigin: {
					vertical: "bottom",
					horizontal: "right",
				},
				transformOrigin: {
					vertical: "top",
					horizontal: "right",
				}
			}} onChange={e => this.updateViewerSettingId(e.target.value.id)}>
				{Object.values(this.props.viewerSettings)
					.filter(viewerSetting => viewerSetting !== this.props.viewerSetting)
					.map(viewerSetting => <MenuItem value={viewerSetting}>{viewerSetting.name}</MenuItem>)}
				<TextField color='secondary' margin='normal' variant={"outlined"} placeholder={"+ new"}
						   size="small" sx={{px: 1, mx: 0, width: 80,}}
						   inputProps={{maxLength: 15}}
						   onKeyDown={(e) =>
							   e.keyCode === 13 ? [this.props.dispatch(createViewerSetting({
								   ...this.props.bloodViewerSetting,
								   name: e.target.value,
							   })), e.target.value = ''] : e.stopPropagation()}/>
			</Select>
		</Tooltip>

	render() {
		if (!this.props.bloodViewerSetting)
			return <LoadingText/>;

		this.backup();

		let viewerSettingsSelect =
			<Grid container paddingBottom={1} direction={"row"} justifyContent={"space-between"}>
				<Tooltip title={"Restore"} placement={"right"}>
					<IconButton color={"secondary"} onClick={() => this.restoreSettings()}>
						<ReplayOutlined/>
					</IconButton>
				</Tooltip>
				<FormControl variant="standard">
					{this.getViewerSettingsDropdown()}
				</FormControl>
			</Grid>

		return <Stack direction={"column"} spacing={2}>
			{viewerSettingsSelect}
			{[BrightnessKey, ContrastKey].map(setting => getSettingComponent(setting,
				this.props.bloodViewerSetting[setting.name.toLowerCase()], value => this.update(setting, value)))}
		</Stack>
	}
}

export default connect(mapStateToProps)(SettingsApp);
